import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {updateOrder} from 'src/openapi/admin/apis/ConferenceSectionsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    onSuccess: () => void,
};

export const useReorderSections = ({onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((requestBody: Record<string, number>) => apiDispatch(
        updateOrder({requestBody}),
    ), [apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
    });
};
